import { render, staticRenderFns } from "./KategoriPage.vue?vue&type=template&id=98f3f3d2"
import script from "./KategoriPage.vue?vue&type=script&lang=js"
export * from "./KategoriPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports